module.exports = __webpack_public_path__ + "img/bomberBP.8b93336b.png";